import React from 'react'
import { Box, Stack } from '@mui/material'
import { LoadConfirmFormContainer } from '../forms.styles'
import TextInputField from '../../fields/text-input-field/text-input-field.component'
import FormSingleColumnLayout from '../../../layouts/form-single-column-layout/form-single-column-layout'

type LoadRateFormProps = {
  compact?: boolean
  displayVariant?: 'default' | 'orderDetails'
}

const LoadRateForm = ({
  compact = false,
  displayVariant = 'default',
}: LoadRateFormProps) => {
  const isOrderDetails = displayVariant === 'orderDetails'

  if (isOrderDetails) {
    return (
      <Box sx={{ width: '100%', maxWidth: 760 }}>
        <Stack spacing={2.5}>
          <TextInputField
            label="Currency"
            name="currency"
            layout="horizontal"
          />
          <TextInputField
            type="number"
            label="Base Rate"
            name="baseRate"
            currency
            layout="horizontal"
          />
          <TextInputField
            type="number"
            label="Detention Charges"
            name="detentionCharges"
            currency
            layout="horizontal"
          />
          <TextInputField
            type="number"
            label="Layover Charges"
            name="layoverCharges"
            currency
            layout="horizontal"
          />
          <TextInputField
            type="number"
            label="Fuel Surcharge"
            name="fuelSurcharge"
            currency
            layout="horizontal"
          />
          <TextInputField
            type="number"
            label="Other Charges"
            name="otherCharges"
            currency
            layout="horizontal"
          />
        </Stack>
      </Box>
    )
  }

  return (
    <LoadConfirmFormContainer container spacing={2} $compact={compact}>
      <FormSingleColumnLayout>
        <TextInputField label="Currency" name="currency" highlight />
        <TextInputField
          type="number"
          label="Base Rate"
          name="baseRate"
          highlight
          currency
        />
        <TextInputField
          type="number"
          label="Detention Charges"
          name="detentionCharges"
          currency
        />
        <TextInputField
          type="number"
          label="Layover Charges"
          name="layoverCharges"
          currency
        />
        <TextInputField
          type="number"
          label="Fuel Surcharge"
          name="fuelSurcharge"
          currency
        />
        <TextInputField
          type="number"
          label="Other Charges"
          name="otherCharges"
          currency
        />
      </FormSingleColumnLayout>
    </LoadConfirmFormContainer>
  )
}

export default LoadRateForm
